export default "__VITE_ASSET__D94kPooc__"